module.exports = __webpack_public_path__ + "img/slide3-en.9b872f9f.png";